// @flow
import { GET_ALL_RECIPES } from './actionTypes'

export default ({ pagination, filterGroup }) => ({
  type: GET_ALL_RECIPES,
  payload: {
    pagination,
    filterGroup, // filters, favorites, unFiltered
  }
})